module.exports = __webpack_public_path__ + "static/media/hal-headshot.a5d40bc9.jpg";